import sortMultiFields from "../helpers/sortMultiFields";

//------------------------
// refresh character order
//------------------------
export default function refreshCharacterOrder(characters) {
  //------------------------
  // sort characters (name)
  //------------------------
  characters.sort(sortMultiFields(["name"]));
  //--------
  // return
  //--------
  return characters;
}
